export const DECA_ROUTES = {
  NEW: '/deca-new',
  LIST: '/deca',
  DETAIL: '/deca-detail',
  EDIT: '/deca-edit',
} as const;
